import 'angular-credit-cards';

import { NgModule } from 'ng-metadata/core';
import { FormCreditCardComponent } from './credit-card.component';

import './credit-card.scss';

@NgModule({
  imports: ['credit-cards'],
  declarations: [
    FormCreditCardComponent,
  ],
})
export class FormCreditCardModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/credit-card/credit-card.module.ts